import React, { Fragment } from 'react';
import UserSection from '../UserSection';
import { getSubMenu } from '../utils/menuStatus';
import * as S from './styles';
const CustomerMenuContainer = ({ isDropdownOpen, customer }) => {
    if (typeof customer === 'undefined') {
        return null;
    }
    const { displayName, fullName, accountIds, subMenus, actionItems } = customer;
    return (React.createElement(S.Wrapper, null,
        React.createElement(S.InfoSection, null,
            React.createElement(UserSection, { isDropdownOpen: isDropdownOpen, displayName: displayName, fullName: fullName, accountIds: accountIds })),
        subMenus ? (React.createElement(S.MenuSection, null, subMenus.map((item) => item ? React.createElement(Fragment, { key: item.id }, getSubMenu(item.type, item)) : null))) : null,
        React.createElement(S.MenuSection, null, actionItems.map((item) => (React.createElement(Fragment, { key: item.id }, getSubMenu(item.type, item)))))));
};
export default CustomerMenuContainer;
//# sourceMappingURL=index.js.map